import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { FormSelect, Modal } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import { handleErrorToast, ViewChatImageorFile } from "../CustomFunctions";
import { BASE_URL } from "../../config/axios";
import {
    AddwithBlueCircle,
    AddwithWhiteCircle,
    Attachment,
    DropdownArrow,
    DropdownArrowOption,
    Filter
} from "../AllSvg";
import { formatDateTime, formattedDate, formattedDateLong } from "../Date";
import { useLocation, useNavigate } from "react-router-dom";
import { DocumentSection } from "../FormdataComponent";
import Select from "react-select";
import Dashboardnavbar from "../../layout/Dashboardnavbar";


const CloseTaskRequest = ({ id, getTaskDetails, i }) => {
    const owner = sessionStorage.getItem('email');
    const [show, setShow] = useState(false);
    const handleClose = () => {
        setFormData({
            task_status: "",
            remark: "",
            completed_date: null,
            close_date: null,
            feedback: "",
        })
        setShow(false);
    }
    const handleShow = () => setShow(true);
    const [formData, setFormData] = useState({
        task_status: "",
        remark: "",
        completed_date: null,
        close_date: null,
        feedback: "",
    });

    useEffect(() => {
        if (i.assign_by_email === i.concern_person_email) {
            setFormData((prev) => ({
                ...prev,
                completed_date: formattedDate,
                close_date: formattedDate,
                task_status: "close",
                feedback: formData.remark,

            }))
        }
        else if (owner === i.concern_person_email) {
            setFormData((prev) => ({
                ...prev,
                completed_date: formattedDate,
                task_status: "completed",
            }))
        }
        else {
            setFormData((prev) => ({
                ...prev,
                close_date: formattedDate,
                task_status: "close",
            }))
        }

    }, [owner, i.task_status, i.concern_person_email, i.assign_by_email]);

    //******************Valedation Start********************* */

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = ["remark",];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };


    console.log("tASK STATUS");
    console.log(formData);


    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });
    };


    const handleFormSubmitPut = async (e) => {
        e.preventDefault();
        if (validateForm()) {
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

            try {
                let res = await axios.put(`${BASE_URL}/task/task/${id}/`, formData);

                if (res.status === 200) {
                    await getTaskDetails();
                    handleClose();
                } else {
                    alert(res);
                }
            } catch (err) {
                //   handleErrorToast(err, loadingToastId)
            } finally {
                toast.dismiss(loadingToastId);
            }
        }
    };

    return (
        <>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
            <div>

                <button className="model-button model-button-black my-5px font-weight500" onClick={handleShow}>
                    Close Task
                </button>
            </div>


            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            <div className="flex-column">
                                <label htmlFor="remark" className="form-labels  font-weight500    announce-date font-weight400  font-size-heading">
                                    {owner === i.assign_by_email ? "Task Closing Remark" : "Task Completed Remark"}
                                </label>
                                <textarea
                                    id="remark"
                                    type="text"
                                    name={formData.owner === i.concern_person_email ? "feedback" : "remark"}
                                    placeholder="Remarks"
                                    onChange={handleInputChange}
                                    maxLength={100}
                                    value={formData.owner === i.concern_person_email ? formData.feedback : formData.remark}
                                    className={`form-input-textarea font-weight400 font-size-subheading ${errors.remark ? "error" : inputState.remark ? "success" : ""
                                        }`}
                                />


                                {errors.remark && (
                                    <span className="error-message font-size-text ">{ }</span>
                                )}
                            </div>

                            <div className="button-models">
                                <button className="model-button model-button-cancel   font-weight500" onClick={handleClose}>
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="model-button   font-weight500    model-button-delete    font-size-heading"
                                    onClick={handleFormSubmitPut}
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

const ViewTask = () => {

    const navigate = useNavigate()
    const currentUrl = window.location.href;
    const urlParts = currentUrl.split('/');
    const backUrl = "/" + urlParts[3] + `/criticalIssues`;

    const location = useLocation();
    const { i } = location.state;

    console.log("i")
    console.log(i)
    const backroute = () => {
        navigate(backUrl)
    }

    const [buffer, setBuffering] = useState(true); //buffering logic
    const [task, settaskData] = useState([]);
    const [taskChat, setTaskChat] = useState([]);


    const getTaskDetails = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            const ticket = await axios.get(`${BASE_URL}/task/task/${i}/`);
            settaskData(ticket.data);
            const chat = await axios.get(`${BASE_URL}/ticket/ticketChat-by-ticket/${i}/`);
            setTaskChat(chat.data);
        } catch (err) {
            handleErrorToast(err)
        } finally {
            setBuffering(false); //buffering logic // End Buffering
        }
    };

    useEffect(() => {
        getTaskDetails();
    }, []);


    const gettaskChat = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {

            const res = await axios.get(
                `${BASE_URL}/ticket/ticketChat-by-ticket/${i}/`
            );
            setTaskChat(res.data);
        } catch (err) {
            handleErrorToast(err)
        } finally {
            setBuffering(false); //buffering logic // End Buffering
        }
    };

    return (
        <>
            <Dashboardnavbar name={"Task Details"} url="Task Managment" />
            <div className="content-tabs">
                <>

                    <div className=" ">

                        <div className="flex-row justify-between mb-20">
                            <button className="model-button model-button-black font-weight500" onClick={backroute}>Back</button>

                            <CloseTaskRequest id={task.id} getTaskDetails={getTaskDetails} i={task} />


                        </div>


                        <div className="table-css-white-background ">
                            <div className="flex-row justify-between">
                                <h2>
                                    Ticket ID: {task.id}
                                </h2>
                                <h4>
                                    <span
                                        className="priority-button behavior"
                                        data-status={task.task_status}
                                    >
                                        {task.task_status ? task.task_status.toUpperCase() : ''}
                                    </span>
                                </h4>
                            </div>
                            <div class="ticket-date">
                                Date Submitted:{" "}
                                {formattedDateLong(task.assigndate)}
                            </div>

                            <div class="ticket-desc-header">Title: "{task.task}"</div>
                            <hr />
                            <div className="ticket-desc">
                                <div class="ticket-desc-header">Description of Issue</div>
                                <p>{task.feedback}</p>
                            </div>
                        </div>
                        <hr />
                        <div className="table-css-white-background ">
                            <div className="flex-row justify-between">
                                <h3>
                                    Chat History:
                                </h3>
                                <TaskChatModel i={i} clientemail={task.assigned_by}
                                    clientname={task.assigned_by_name}
                                    ticket_name={task.title}
                                    status={task.status}
                                    getAllTasks={getTaskDetails}
                                    productname={task.ticket_for}

                                />

                            </div>

                            <ul className="chatbox">
                                {buffer ? (
                                    <div className="spinner"></div>
                                ) : taskChat.length === 0 ? (
                                    <div
                                        className="align-center justify-center "
                                        style={{ alignSelf: "center" }}
                                    >
                                        - No Chat Historys 🪹 -
                                    </div>
                                ) : (
                                    <>
                                        {taskChat
                                            .sort(
                                                (a, b) => new Date(a.timestamp) - new Date(b.timestamp)
                                            )
                                            .map((i, index) => (
                                                <>
                                                    {i.sender == sessionStorage.getItem("email") ? (
                                                        <>
                                                            <p className="chat-reply-timestamp font-size-text">
                                                                {i.sender_name}
                                                            </p>
                                                            <div className="chat chat-reply">
                                                                <li className="p-li">
                                                                    {i.message ? (
                                                                        <>
                                                                            <p>{i.message}</p>
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            <ViewChatImageorFile
                                                                                textcss={'chat-photo-reply'}
                                                                                filesrc={i.document}
                                                                            />
                                                                        </>
                                                                    )}

                                                                </li>
                                                                <p className="chat-reply-timestamp pad-r text-right font-size-label">
                                                                    {formatDateTime(i.timestamp).full}
                                                                </p>
                                                            </div>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <p className="chat-incoming-timestamp font-size-text ">
                                                                {i.sender_name}
                                                            </p>
                                                            <div className="chat chat-incoming">
                                                                <li className="p-li">
                                                                    {i.message ? (
                                                                        <>
                                                                            <p>{i.message}</p>
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            <ViewChatImageorFile
                                                                                textcss={'chat-photo-incoming'}
                                                                                filesrc={i.document}
                                                                            />
                                                                        </>
                                                                    )}


                                                                </li>
                                                                <p className="chat-incoming-timestamp pad-r text-right font-size-label">
                                                                    {formatDateTime(i.timestamp).full}
                                                                </p>
                                                            </div>
                                                        </>
                                                    )}
                                                </>
                                            ))}
                                    </>
                                )}
                            </ul>
                        </div>
                    </div>

                </>
            </div>
        </>
    );
};
const AssignTask = ({ getTicketList }) => {
    const [show, setShow] = useState(false);
    const projectID = sessionStorage.getItem('sitemanagement_project');

    const handleClose = () => {
        setShow(false);
        setFormData({
            task: "",
            assigndate: formattedDate,
            due_date: null,
            assigned_by_name: sessionStorage.getItem('name'),
            concern_person: "",
            priority: "",
            feedback: "",
            assign_by_email: sessionStorage.getItem('email'),
            task_status: "pending",
            assignedtocc: [],
            concern_person_email: null,
            task_link: "https://csms.aimantra.co/"

        })
    }
    const handleShow = () => setShow(true);

    const [formData, setFormData] = useState({
        task: "",
        assigndate: formattedDate,
        due_date: null,
        assigned_by_name: sessionStorage.getItem('name'),
        concern_person: "",
        priority: "",
        feedback: "",
        assign_by_email: sessionStorage.getItem('email'),
        task_link: "https://csms.aimantra.co/",

        assignedtocc: [],
        task_status: "pending",
        concern_person_email: "",
    });


    // !  ************** Validation start **************  ! //

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});
    const [isSubmitted, setIsSubmitted] = useState(false);

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = [
            "task",
            "due_date",
            "concern_person_email",
            "priority",
        ];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);
        setIsSubmitted(true);

        return Object.keys(newErrors).length === 0;
    };

    // ?  ************** Validation End **************  ! //
    const [loading, setLoading] = useState(false); //loading logic

    const handleSubmit = async (e) => {

        e.preventDefault();

        if (validateForm()) {

            setLoading(true); //loading logic

            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

            try {
                let res = await axios.post(`${BASE_URL}/task/task/`, formData);

                if (res.status === 200) {
                    // await getTicketList();
                    handleClose();
                } else {
                    alert(res);
                }
            } catch (err) {
                // handleErrorToast(err, loadingToastId);
                console.log(err);

            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };


    const [employeeData, setEmployeeData] = useState([]);

    const getEmployeeData = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/siteproject/employeebyfiltersss/${projectID ? projectID : "null"}/`);
            setEmployeeData(response.data);
        } catch (error) {
            console.error(error);

        }
    }



    useEffect(() => {
        getEmployeeData();
    }, [projectID]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });

        if (value.trim()) {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[name];
                return updatedErrors;
            });
        }
    };

    const handleEmployeeChange = (selectedOption) => {
        if (!selectedOption) {
            // Reset to null when cleared
            setFormData({
                ...formData,
                concern_person: "",
                concern_person_email: "",
            });
        } else {
            setFormData({
                ...formData,
                concern_person: selectedOption.name,
                concern_person_email: selectedOption.email,
            });
        }

        setErrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };
            delete updatedErrors.concern_person;
            delete updatedErrors.concern_person_email;
            return updatedErrors;
        });
    };

    const employeeOptions = [
        { value: "null", label: "Select Employee" },
        ...employeeData.map((emp) => ({
            value: emp.email,
            label: `${emp.emp_code} - ${emp.name}`,
            name: emp.name,
            email: emp.email,
        })),
    ];

    const handleChangecc = (selected) => {
        const assignedtocc =
            selected.length > 0 ? selected.map((item) => item.value) : "";
        setFormData((prevState) => ({
            ...prevState,
            assignedtocc,
        }));
    };
    const options = employeeData
        .sort((a, b) => (a.emp_code) - (b.name))
        .map((e) => ({
            value: e.email,
            label: `${e.emp_code} - ${e.name}`,
        }));



    return (
        <>
            <button
                title="Raise a New Request"
                className="upload-svg"
                onClick={handleShow}
            >
                <AddwithWhiteCircle /> New Task
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Add Assign Task</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            <div title="task" className="flex-column">
                                <label
                                    htmlFor="task"
                                    className="form-labels font-weight500 font-size-heading"
                                >
                                    Name of Task <span className="required">*</span>
                                </label>
                                <textarea
                                    id="task"
                                    type="text"
                                    name="task"
                                    maxLength={300}
                                    placeholder="Enter task"
                                    onChange={handleInputChange}
                                    value={formData.task}
                                    className={`form-input-textarea ${errors.task ? "error" : inputState.task ? "success" : ""
                                        }`}
                                />
                                {errors.task && (
                                    <span className="error-message">{errors.task}</span>
                                )}
                            </div>
                            <div title="Assigned To" className="flex-column">
                                <label
                                    htmlFor="Assigned To"
                                    className="form-labels font-weight500 font-size-heading"
                                >
                                    Assigned To <span className="required">*</span>
                                </label>
                                <Select
                                    options={employeeOptions}
                                    onChange={handleEmployeeChange}
                                    value={employeeOptions.find(option => option.value === formData.concern_person_email)}
                                    placeholder="Select or Search Employee"
                                    // className={`form-input ${errors.assigned_to ? "error" : inputState.assigned_to ? "success" : ""}`}
                                    isSearchable
                                    isClearable
                                    noOptionsMessage={() => "No other options"}
                                    styles={{
                                        control: (provided) => ({
                                            ...provided,
                                            width: '33vw',
                                            height: '50px',
                                            borderRadius: '10px',
                                            border: '1px solid #e3e3e3',
                                            margin: '10px 0px 20px 0px',
                                            color: '#4a4a4a',
                                            backgroundColor: '#f7f8fa',
                                            padding: '0px 10px',
                                        }),
                                        placeholder: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),
                                        menu: (provided) => ({
                                            ...provided,
                                            width: '33vw',
                                            borderRadius: '10px',
                                            marginTop: '0',
                                        }),
                                        menuPortal: (provided) => ({
                                            ...provided,
                                        }),
                                        singleValue: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),
                                        input: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),
                                    }}

                                />
                                {errors.concern_person_email && (
                                    <span className="error-message">{errors.concern_person_email}</span>
                                )}
                            </div>
                            <div title="Assigned To CC" className="flex-column">
                                <label
                                    htmlFor="Assigned To CC"
                                    className="form-labels font-weight500 font-size-heading"
                                >
                                    Assigned To CC
                                </label>
                                <Select
                                    options={options}
                                    isMulti
                                    onChange={handleChangecc}
                                    styles={{
                                        control: (provided) => ({
                                            ...provided,
                                            width: '33vw',
                                            minHeight: '50px', // use minHeight instead of fixed height
                                            borderRadius: '10px',
                                            border: '1px solid #e3e3e3',
                                            margin: '10px 0px 20px 0px',
                                            color: '#4a4a4a',
                                            backgroundColor: '#f7f8fa',
                                            padding: '0px 10px',
                                            flexWrap: 'wrap', // important for multiline
                                        }),
                                        multiValue: (provided) => ({
                                            ...provided,
                                            backgroundColor: '#e2e6ea',
                                            borderRadius: '5px',
                                            padding: '2px',
                                        }),


                                        placeholder: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),
                                        menu: (provided) => ({
                                            ...provided,
                                            width: '33vw',
                                            borderRadius: '10px',
                                            marginTop: '0',
                                        }),
                                        singleValue: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),
                                        input: (provided) => ({
                                            ...provided,
                                            color: '#4a4a4a',
                                        }),
                                    }}
                                />
                                {errors.assignedtocc && (
                                    <span className="error-message">{errors.assignedtocc}</span>
                                )}
                            </div>
                            <div title="Deadline Date" className="flex-column">
                                <label
                                    htmlFor="due_date "
                                    className="form-labels font-weight500 font-size-heading"
                                >
                                    Deadline Date  <span className="required">*</span>
                                </label>
                                <input
                                    id="due_date"
                                    type="date"
                                    name="due_date"
                                    maxLength={300}
                                    placeholder="Enter due_date"
                                    onChange={handleInputChange}
                                    value={formData.due_date}
                                    className={`form-input ${errors.due_date ? "error" : inputState.due_date ? "success" : ""
                                        }`}
                                />
                                {errors.due_date && (
                                    <span className="error-message">{errors.due_date}</span>
                                )}
                            </div>
                            <div title="Priority" className="flex-column form-group-selectt">
                                <label htmlFor="priority" className="form-labels font-weight500    font-size-subheading">
                                    Priority<span className="required">*</span>
                                </label>
                                <br />
                                <select
                                    id="priority"
                                    name="priority"
                                    value={formData.priority}
                                    onChange={handleInputChange}
                                    className={`form-input form-group-selection ${errors.priority ? "error" : inputState.priority ? "success" : ""
                                        }`}
                                >
                                    <option value="">Select Priority</option>
                                    <option value="low">Low</option>
                                    <option value="medium">Medium</option>
                                    <option value="high">High</option>
                                </select>

                                <div>
                                    {errors.priority && (
                                        <span className="error-message font-size-text ">{errors.priority}</span>
                                    )}
                                </div>
                            </div>









                            <div className="button-models">
                                <button
                                    className="model-button model-button-cancel font-weight500"
                                    type="button"
                                    onClick={handleClose}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
                                    onClick={handleSubmit}
                                    disabled={loading}
                                >
                                    Submit
                                </button>
                            </div>
                        </div>
                        <p className="error-message font-size-text">
                            {isSubmitted && Object.keys(errors).length > 0 && (
                                Object.keys(errors).length > 5 ? (
                                    <h5 className="text-center">Please fill all mandatory fields!</h5>
                                ) : (

                                    <h6 className="text-center">
                                        {Object.keys(errors).map((field) =>
                                            field.charAt(0).toUpperCase() + field.slice(1)
                                        ).join(', ') + ' are required!'}
                                    </h6>
                                )
                            )}
                        </p>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};

const RaiseTicketWithDocument = ({ getTicketList }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => {
        setFormData({
            title: "",
            description: "",
            assign_date: formattedDate,
            due_date: "",
            assigned_by_name: sessionStorage.getItem("name") || "",
            assigned_by: sessionStorage.getItem("email") || "",
            status: "pending",
            documents: [{ document_name: "", document_file: "" }],
        });
        setFileNames([]);
        setShow(false);
    };
    const handleShow = () => setShow(true);

    const [fileNames, setFileNames] = useState([]);

    const [formData, setFormData] = useState({
        title: "",
        description: "",
        assign_date: formattedDate,
        due_date: "",
        assigned_by_name: sessionStorage.getItem("name") || "",
        assigned_by: sessionStorage.getItem("email") || "",
        status: "pending",
        documents: [{ document_name: "", document_file: "" }],
    });

    // !  ************** Validation start **************  ! //

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = [
            "title",
            "description",
            "assign_date",
            "due_date",
            "assigned_by_name",
            "assigned_by",
        ];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    // ?  ************** Validation End **************  ! //
    const [loading, setLoading] = useState(false); //loading logic

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setLoading(true); //loading logic
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

            try {
                let res = await axios.post(
                    `${BASE_URL}/ticket/document-bulk-with-ticket/`,
                    formData
                );

                if (res.status === 200) {
                    await getTicketList();
                    setShow(false);
                } else {
                    alert(res);
                }
            } catch (err) {
                handleErrorToast(err, loadingToastId);
                console.log(err);
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });

        setErrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };
            if (value) {
                delete updatedErrors[name];
            }
            return updatedErrors;
        });
    };

    const handleDocInputChange = (index, e) => {
        const { name, value, files } = e.target;

        setFormData((prevFormData) => {
            const newDocuments = [...prevFormData.documents];
            newDocuments[index] = {
                ...newDocuments[index],
                [name]: files ? files[0] : value, // Removed .trim()
            };

            if (files) {
                setFileNames((prevFileNames) => {
                    const newFileNames = [...prevFileNames];
                    newFileNames[index] = files[0]?.name || "";
                    return newFileNames;
                });
            }

            return { ...prevFormData, documents: newDocuments };
        });
    };

    const handleAddDocuments = () => {
        setFormData((prevFormData) => ({
            ...prevFormData,
            documents: [
                ...prevFormData.documents,
                { document_name: "", document_file: null },
            ],
        }));
    };

    const handleRemoveDocument = (index) => {
        setFormData((prevFormData) => ({
            ...prevFormData,
            documents: prevFormData.documents.filter((_, i) => i !== index),
        }));
        setFileNames((prevFileNames) =>
            prevFileNames.filter((_, i) => i !== index)
        );
    };

    console.log("formData");
    console.log(formData);
    const currentUrl = window.location.href;
    const urlParts = currentUrl.split("/");
    const FRONTEND_URL = urlParts[0] + `//` + urlParts[2];

    const domainParts = urlParts[2].split(".");
    console.log(domainParts, FRONTEND_URL, 'frontend url');
    return (
        <>
            <button
                title="Raise a New Request"
                className="upload-svg"
                onClick={handleShow}
            >
                <AddwithWhiteCircle /> New Ticket
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="half-modal width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Raise a Ticket Request</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            <div title="Title" className="flex-column">
                                <label
                                    htmlFor="title"
                                    className="form-labels font-weight500 font-size-heading"
                                >
                                    Title<span className="required">*</span>
                                </label>
                                <input
                                    id="title"
                                    type="text"
                                    name="title"
                                    maxLength={300}
                                    placeholder="Enter Title"
                                    onChange={handleInputChange}
                                    value={formData.title}
                                    className={`form-input ${errors.title ? "error" : inputState.title ? "success" : ""
                                        }`}
                                />
                                {errors.title && (
                                    <span className="error-message">{errors.title}</span>
                                )}
                            </div>

                            <div title="Description" className="flex-column">
                                <label
                                    htmlFor="description"
                                    className="form-labels font-weight500 font-size-heading"
                                >
                                    Description<span className="required">*</span>
                                </label>
                                <textarea
                                    id="description"
                                    name="description"
                                    placeholder="Enter Description"
                                    onChange={handleInputChange}
                                    value={formData.description}
                                    className={`form-input-textarea ${errors.description
                                        ? "error"
                                        : inputState.description
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.description && (
                                    <span className="error-message">{errors.description}</span>
                                )}
                            </div>

                            <div title="Due Date" className="flex-column">
                                <label
                                    htmlFor="due_date"
                                    className="form-labels font-weight500 font-size-heading"
                                >
                                    Due Date<span className="required">*</span>
                                </label>
                                <input
                                    id="due_date"
                                    type="date"
                                    name="due_date"
                                    onChange={handleInputChange}
                                    value={formData.due_date}
                                    className={`form-input ${errors.due_date
                                        ? "error"
                                        : inputState.due_date
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.due_date && (
                                    <span className="error-message">{errors.due_date}</span>
                                )}
                            </div>

                            <div title="Assigned By Name" className="flex-column">
                                <label
                                    htmlFor="assigned_by_name"
                                    className="form-labels font-weight500 font-size-heading"
                                >
                                    Customer Name<span className="required">*</span>
                                </label>
                                <input
                                    id="assigned_by_name"
                                    type="text"
                                    name="assigned_by_name"
                                    maxLength={150}
                                    placeholder="Enter Assigned By Name"
                                    onChange={handleInputChange}
                                    value={formData.assigned_by_name}
                                    className={`form-input ${errors.assigned_by_name
                                        ? "error"
                                        : inputState.assigned_by_name
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.assigned_by_name && (
                                    <span className="error-message">
                                        {errors.assigned_by_name}
                                    </span>
                                )}
                            </div>

                            <div title="Assigned By" className="flex-column">
                                <label
                                    htmlFor="assigned_by"
                                    className="form-labels font-weight500 font-size-heading"
                                >
                                    Customer Email<span className="required">*</span>
                                </label>
                                <input
                                    id="assigned_by"
                                    type="email"
                                    name="assigned_by"
                                    placeholder="Enter Email"
                                    onChange={handleInputChange}
                                    onInput={(e) => {
                                        e.target.value = e.target.value.toLowerCase().trim(); // Convert input to lowercase
                                    }}
                                    value={formData.assigned_by}
                                    className={`form-input ${errors.assigned_by
                                        ? "error"
                                        : inputState.assigned_by
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.assigned_by && (
                                    <span className="error-message">{errors.assigned_by}</span>
                                )}
                            </div>

                            <DocumentSection
                                formData={formData}
                                handleDocInputChange={handleDocInputChange}
                                handleAddDocuments={handleAddDocuments}
                                handleRemoveDocument={handleRemoveDocument}
                                errors={errors}
                                fileNames={fileNames}
                                inputState={inputState}
                            />

                            <div className="button-models">
                                <button
                                    className="model-button model-button-cancel font-weight500"
                                    type="button"
                                    onClick={handleClose}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
                                    onClick={handleSubmit}
                                    disabled={loading}
                                >
                                    Raise Request
                                </button>
                            </div>
                        </div>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};

const TaskChatModel = ({ i, clientemail, receiver_name, receiver, clientname, name, status, productname }) => {


    console.log("name")
    console.log(name)

    const chatboxRef = useRef(null);
    const [chatShow, setChatShow] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleChatOpen = (id) => {
        getTicketChat();
        setChatShow(true);
    };

    const handleChatClose = () => {
        setChatShow(false);
    };

    const [formData, setFormData] = useState({
        task: "",
        sender: sessionStorage.getItem("email") || "",
        sender_name: sessionStorage.getItem("name") || "",
        message: "",
        task_name: "",
        image: '',
        document: null,
        timestamp: new Date().toISOString(),
        read_status: false,
        receiver_email: "",
        receiver_name: "",
        task_link: 'https://csms.aimantra.co/'


    });
    console.log("formData")
    console.log(formData)


    useEffect(() => {

        if (clientemail === sessionStorage.getItem('email')) {
            setFormData((prev) => ({
                ...prev,
                receiver_email: receiver,
                receiver_name: receiver_name,
                task: i,
                task_name: name,
            }))
        }
        else {
            setFormData((prev) => ({
                ...prev,
                receiver_email: clientemail,
                receiver_name: clientname,
                task: i,
                task_name: name,
            }))
        }

    }, [clientname, clientemail, name, receiver_name, receiver]);



    console.log("formData");
    console.log(clientemail);



    const handleInputChange = (e) => {
        const { name, value, type, checked, options, files } = e.target;

        let newValue;
        console.log(value, 'newvalue')
        if (type === "select-multiple") {
            newValue = Array.from(options)
                .filter((option) => option.selected)
                .map((option) => option.value);
        } else if (type === "checkbox") {
            newValue = checked;
        } else if (type === "file") {
            if (files.length > 0) {
                newValue = files
            } else {
                newValue = null;
            }
        } else {
            newValue = value;
        }

        console.log(newValue)
        setInputState((prevState) => ({
            ...prevState,
            [name]:
                type === "checkbox"
                    ? checked
                        ? "green"
                        : ""
                    : newValue
                        ? "green"
                        : "",
        }));


        setFormData((prevFormData) => {
            const updatedFormData = {
                ...prevFormData,
                [name]: newValue,
            };

            return updatedFormData;
        });

        // for removing error by clicking on input if any errors show 
        if (value.trim()) {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[name];
                return updatedErrors;
            });
        }
    };

    const handleFileChange = (e) => {
        const { name, value } = e.target;
        const file = e.target.files[0];

        if (file) {
            setFormData({ ...formData, [name]: file, });
            setFileName(file.name);
        } else {
            setFileName("");
        }

        if (value.trim()) {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[name];
                return updatedErrors;
            });
        }

    };
    const handleClear = () => {
        setFormData(prevState => ({
            ...prevState,
            document: null
        }));
        setFileName("");

    }

    // !  ************** Validation start **************  ! //

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});
    const [fileName, setFileName] = useState("");

    console.log(formData.files !== "")
    const validateForm = () => {
        const newErrors = {};
        const requiredFields = [
            formData.document !== null ? null : "message",
        ].filter(Boolean);
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        console.log("newErrors");
        console.log(newErrors);

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };


    const handleSendTaskRemark = async (e) => {

        if (e && e.preventDefault) {
            e.preventDefault();
        }

        console.log("formData");
        console.log(formData);

        if (validateForm()) {
            setLoading(true);
            // const loadingToastId = toast.loading("Loading: Please wait...");

            const formDataToSend = new FormData();
            // Object.keys(formData).forEach((key) => {
            //     if (formData[key] && key !== "document") {
            //         formDataToSend.append(key, formData[key]);
            //     }
            // });

            Object.keys(formData).forEach((key) => {
                if (key !== "document") {
                    formDataToSend.append(key, formData[key]);
                }
            });


            const symbols = '!@#$%^&*()_-+=';
            const lowercaseLetters = 'abcdefghijklmnopqrstuvwxyz';
            const uppercaseLetters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
            const numbers = '0123456789';
            const now = new Date();
            let date = now.toLocaleDateString('en-GB').split('/').reverse().join('-'); // Format: YYYY-MM-DD
            let time = now.toLocaleTimeString('en-GB', { hour12: false }).replace(/:/g, '-'); // Format: HH-MM-SS
            const allChars = symbols + lowercaseLetters + uppercaseLetters + numbers;
            let randomCode = '';
            for (let i = 0; i < 8; i++) {
                const randomIndex = Math.floor(Math.random() * allChars.length);
                randomCode += allChars[randomIndex];
            }

            let originalFile, customFileName, customFile;
            if (formData.document) {
                originalFile = formData.document;
                customFileName = `Aimantra ${date} ${time}_${randomCode} ${originalFile.name}`;
                customFile = new File([originalFile], customFileName, { type: originalFile.type });
                formDataToSend.append("document", customFile);
            }

            try {
                let res = await axios.post(`${BASE_URL}/task/taskChat/`, formDataToSend, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                });

                if (res.status === 200) {
                    await getTicketChat();
                    setFormData({
                        ...formData,
                        message: "",
                        files: '',
                    });
                } else {
                    alert(res);
                }
            } catch (err) {
                // handleErrorToast(err, loadingToastId);
                handleErrorToast(err);
            } finally {
                setLoading(false);
                // toast.dismiss(loadingToastId);
            }
        }
    };
    // !########################################################################

    const [ticketChat, setTicketChat] = useState([]);
    const [buffer, setBuffering] = useState(true); //buffering logic
    const getFileNameFromLink = (url) => {
        try {
            const ImgFileUrl = "https://cipl-aimantra.s3.amazonaws.com/" || "https://cipl-aimantra.s3.ap-south-1.amazonaws.com/";
            // const ImgFileUrl = "https://cipl-aimantra.s3.amazonaws.com/" || "https://cipl-aimantra.s3.ap-south-1.amazonaws.com/";

            if (url.startsWith(ImgFileUrl)) {
                const pathAfterBase = url.slice(ImgFileUrl.length);

                const fileName = pathAfterBase.split('/').slice(1).join('/').split('?')[0];

                return fileName;
            }

            return url;
        } catch (error) {
            console.error("Error extracting file name:", error);
            return "";
        }
    };
    const getTicketChat = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            const res = await axios.get(
                `${BASE_URL}/task/taskchatbytask/${i}/`
            );
            setTicketChat(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false); //buffering logic // End Buffering
        }
    };

    useEffect(() => {
        // Scroll to the bottom whenever new messages arrive
        if (chatboxRef.current) {
            chatboxRef.current.scrollTop = chatboxRef.current.scrollHeight;
        }
    }, [ticketChat]); // Runs whenever ticketChat updates

    return (
        <>
            <button onClick={() => handleChatOpen(i)}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="40"
                    height="40"
                    viewBox="0 0 64 64"
                    id="chat-box"
                    fill="none"
                >
                    <path
                        fill="#2576BC"
                        d="M40,54.78a3,3,0,0,1-1.89-.68l-7.73-6.33a1,1,0,1,1,1.26-1.54l7.74,6.32A1,1,0,0,0,41,51.78V47a1,1,0,0,1,1-1,5.07,5.07,0,0,0,5-5V25a4.94,4.94,0,0,0-4.86-5H10.86A4.94,4.94,0,0,0,6,25V41a4.94,4.94,0,0,0,4.86,5H25.52a1,1,0,0,1,0,2H10.86A6.94,6.94,0,0,1,4,41V25a6.94,6.94,0,0,1,6.86-7H42.14A6.94,6.94,0,0,1,49,25V41a7,7,0,0,1-6,6.93v3.85a3,3,0,0,1-1.72,2.71A2.93,2.93,0,0,1,40,54.78ZM53.14,38a1,1,0,0,1,0-2A4.94,4.94,0,0,0,58,31V15a4.94,4.94,0,0,0-4.86-5H21.87a4.88,4.88,0,0,0-4.8,4.16,1,1,0,1,1-2-.32A6.88,6.88,0,0,1,21.87,8H53.14A6.94,6.94,0,0,1,60,15V31A6.94,6.94,0,0,1,53.14,38ZM37,35a2,2,0,1,1,2-2A2,2,0,0,1,37,35ZM26,35a2,2,0,1,1,2-2A2,2,0,0,1,26,35ZM15,35a2,2,0,1,1,2-2A2,2,0,0,1,15,35Z"
                    ></path>
                </svg>
            </button>

            <Modal
                show={chatShow}
                onHide={handleChatClose}
                dialogClassName="request-leave "
            >
                <Modal.Header closeButton>
                    <Modal.Title>Task Chat History</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="flex-column ">
                        <ul className="chatbox" ref={chatboxRef} style={{ overflowY: "auto", maxHeight: "500px" }}>
                            {buffer ? <div className="spinner-z"></div> : null}
                            {ticketChat.length === 0 ? (
                                <div className="align-center justify-center" style={{ alignSelf: "center" }}>
                                    - No Chat Historys 🪹 -
                                </div>
                            ) : (
                                ticketChat
                                    .sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp))
                                    .map((i, index) => (
                                        <div key={index}>
                                            {i.sender === sessionStorage.getItem("email") ? (
                                                <>
                                                    <p className="chat-reply-timestamp font-size-text">{i.sender_name}</p>
                                                    <div className="chat chat-reply" style={{ padding: "10px" }}>
                                                        <li className="p-li">
                                                            {i.message ? <p>{i.message}</p> : <ViewChatImageorFile textcss="chat-photo-reply" filesrc={i.document} />}
                                                        </li>
                                                        <p className="chat-reply-timestamp pad-r text-right font-size-label">
                                                            {formatDateTime(i.timestamp).full}
                                                        </p>
                                                    </div>
                                                </>
                                            ) : (
                                                <>
                                                    <p className="chat-incoming-timestamp font-size-text">{i.sender_name}</p>
                                                    <div className="chat chat-incoming">
                                                        <li className="p-li">
                                                            {i.message ? <p>{i.message}</p> : <ViewChatImageorFile textcss="chat-photo-incoming" filesrc={i.document} />}
                                                        </li>
                                                        <p className="chat-incoming-timestamp pad-r text-right font-size-label">
                                                            {formatDateTime(i.timestamp).full}
                                                        </p>
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                    ))
                            )}
                        </ul>
                        {/* <ul className="chatbox">
                            {buffer ? (
                                <div className="spinner-z"></div>
                            ):null}
                            {ticketChat.length === 0 ? (
                                <div
                                    className="align-center justify-center "
                                    style={{ alignSelf: "center" }}
                                >
                                    - No Chat Historys 🪹 -
                                </div>
                            ) : (
                                <>
                                    {ticketChat
                                        .sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp))
                                        .map((i, index) => (
                                            <>
                                                {i.sender == sessionStorage.getItem("email") ? (
                                                    <>
                                                        <p className="chat-reply-timestamp font-size-text">
                                                            {i.sender_name}
                                                        </p>

                                                        <div className="chat chat-reply">
                                                            <li className="p-li">
                                                                {i.message ? (
                                                                    <>
                                                                        <p>{i.message}</p>
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <ViewChatImageorFile
                                                                            textcss={'chat-photo-reply'}
                                                                            filesrc={i.document}
                                                                        />
                                                                    </>
                                                                )}

                                                            </li>
                                                            <p className="chat-reply-timestamp pad-r text-right font-size-label">
                                                                {formatDateTime(i.timestamp).full}
                                                            </p>
                                                        </div>

                                                    </>
                                                ) : (
                                                    <>
                                                        <p className="chat-incoming-timestamp font-size-text ">
                                                            {i.sender_name}
                                                        </p>

                                                        <div className="chat chat-incoming">
                                                            <li className="p-li">
                                                                {i.message ? (
                                                                    <>
                                                                        <p>{i.message}</p>
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <ViewChatImageorFile
                                                                            textcss={'chat-photo-incoming'}
                                                                            filesrc={i.document}
                                                                        />
                                                                    </>
                                                                )}


                                                            </li>
                                                            <p className="chat-incoming-timestamp pad-r text-right font-size-label">
                                                                {formatDateTime(i.timestamp).full}
                                                            </p>
                                                        </div>


                                                    </>
                                                )}
                                            </>
                                        ))}
                                </>

                            )}
                        </ul> */}
                        {status !== "completed" ?
                            <div>
                                <div className="flex-row justify-betweeen chat-input"
                                    style={{ height: "43px" }}
                                >

                                    {formData.document ?
                                        <>
                                            <div className="chat-input-textarea">
                                                {fileName && <p style={{ margin: "0px" }}>{fileName}</p>}
                                            </div>
                                            <button className="chat-clear" onClick={handleClear}>Clear</button>
                                        </>
                                        :

                                        <textarea
                                            id="message"
                                            name="message"
                                            maxLength={500}
                                            placeholder="Enter Message"
                                            onChange={handleInputChange}
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter" && !e.shiftKey) {
                                                    e.preventDefault();
                                                    handleSendTaskRemark();
                                                }
                                            }}
                                            value={formData.message}
                                            style={{ height: "20px", minHeight: "20px", resize: "vertical" }}
                                            className={`textarea-custom ${errors.message ? "textarea-error" : inputState.message ? "textarea-success" : ""}`}
                                        />




                                    }

                                    {formData.document && (
                                        <div>
                                            <span>{formData.document.fileName}</span>


                                            {formData.document.previewUrl && (
                                                <img src={formData.document.previewUrl} alt="File Preview" width={100} />
                                            )}
                                        </div>
                                    )}

                                    <div className="btn-cont align-end gap-const" style={{ flexWrap: "nowrap" }}>

                                        <label htmlFor="document" >
                                            <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M20 7V6.8C20 5.11984 20 4.27976 19.673 3.63803C19.3854 3.07354 18.9265 2.6146 18.362 2.32698C17.7202 2 16.8802 2 15.2 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H12.5M18 18V12.5C18 11.6716 18.6716 11 19.5 11C20.3284 11 21 11.6716 21 12.5V18C21 19.6569 19.6569 21 18 21C16.3431 21 15 19.6569 15 18V14" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>
                                            <input
                                                id="document"
                                                name="document"
                                                type="file"
                                                accept=".pdf, .doc, .docx, .png, .jpeg, .jpg"
                                                onChange={handleFileChange}
                                                onFocus={handleClear}
                                                style={{ display: "none", position: "relative" }}

                                                className={`  ${errors.document ? "error" : inputState.document ? "success" : ""
                                                    }`}
                                            />
                                        </label>




                                        <button onClick={handleSendTaskRemark} disabled={loading}>
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                enable-background="new 0 0 32 32"
                                                viewBox="0 0 32 32"
                                                id="send"
                                                width="30"
                                                height="30"
                                            >
                                                <path
                                                    fill="#2576BC"
                                                    d="M30.5,14.58997l-28-10c-0.54999-0.19995-1.16998-0.04999-1.58002,0.37C0.51001,5.38,0.39001,6.01001,0.60999,6.56l2.91882,7.31079C3.68054,14.25073,4.0484,14.5,4.45752,14.5h7.70245c0.83002,0,1.5,0.66998,1.5,1.5c0,0.82996-0.66998,1.5-1.5,1.5H4.45752c-0.40912,0-0.77698,0.24921-0.92871,0.62921L0.60999,25.44c-0.21997,0.54999-0.09998,1.17999,0.31,1.59998C1.21002,27.33997,1.59998,27.5,2,27.5c0.16998,0,0.34003-0.03003,0.5-0.09003l28-10c0.59998-0.20996,1-0.77997,1-1.40997S31.09998,14.79999,30.5,14.58997z"
                                                ></path>
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                            </div> :
                            <p className="text-center">
                                "Task Completed"
                            </p>
                        }
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    {errors.message && (
                        <span className="error-message font-size-text ">
                            {errors.message}
                        </span>
                    )}
                </Modal.Footer>
            </Modal>
        </>
    );
};

export { AssignTask, RaiseTicketWithDocument, TaskChatModel, ViewTask, CloseTaskRequest };
